export default {
  default_browser_tag: 'FoodAmigos - Bestel online',
  seo: {
    title: '{{name}} - bestel eten online in {{city}}',
    description: '{{name}} in {{city}}. Officieel menu. Bespaar geld en bestel online.',
  },
};
